import { TFunction } from 'react-i18next';
import { ISelectorData } from '../../components/application/NewApplication';
import React from 'react';
import {
	IPaymentReportFields,
	PAYMENT_REPORT_FORM_FIELDS,
	PAYMENT_REPORT_FORM_FIELDS_NAMES
} from './payment-report-form';
import { timeZonesList } from '../../components/profileSettings/ProfileSettingsPreferences';
import { InputType } from '../../components/form/form-input-constants';

interface IReportFieldsProps {
	t: TFunction,
	merchantsListReport: ISelectorData[];
	renderMenu?: (menu: React.ReactElement) => React.ReactElement;
	searchBy?: (keyword: string) => boolean;
	reportTypesList?: any;

}

export const PAYMENT_REPORT_FIELDS = ({ t, merchantsListReport, renderMenu, searchBy, reportTypesList }: IReportFieldsProps): IPaymentReportFields[] => {
	return [
		{
			key: PAYMENT_REPORT_FORM_FIELDS.REPORT_TYPE,
			fieldName: PAYMENT_REPORT_FORM_FIELDS.REPORT_TYPE,
			placeholder: `${t(PAYMENT_REPORT_FORM_FIELDS_NAMES.REPORT_TYPE)}`,
			label: t(PAYMENT_REPORT_FORM_FIELDS_NAMES.REPORT_TYPE),
			inputType: InputType.Select,
			data: reportTypesList,
			required: true
		},
		{
			key: PAYMENT_REPORT_FORM_FIELDS.MERCHANT,
			fieldName: PAYMENT_REPORT_FORM_FIELDS.MERCHANT,
			placeholder: `${t(PAYMENT_REPORT_FORM_FIELDS_NAMES.MERCHANT)}`,
			label: t(PAYMENT_REPORT_FORM_FIELDS_NAMES.MERCHANT),
			inputType: InputType.Select,
			data: merchantsListReport,
			placement: 'bottomEnd',
			renderMenu: renderMenu,
			searchBy: searchBy
		},
		{
			key: PAYMENT_REPORT_FORM_FIELDS.DATE_START,
			fieldName: PAYMENT_REPORT_FORM_FIELDS.DATE_START,
			placeholder: 'Select date',
			label: t(PAYMENT_REPORT_FORM_FIELDS_NAMES.DATE_START),
			inputType: InputType.Date,
			required: true,
			isTimePicker: true,
		},
		{
			key: PAYMENT_REPORT_FORM_FIELDS.DATE_END,
			fieldName: PAYMENT_REPORT_FORM_FIELDS.DATE_END,
			placeholder: 'Select date',
			label: t(PAYMENT_REPORT_FORM_FIELDS_NAMES.DATE_END),
			inputType: InputType.Date,
			placement: 'bottomEnd',
			required: true,
			isTimePicker: true,

		},
		{
			key: PAYMENT_REPORT_FORM_FIELDS.TIMEZONE,
			fieldName: PAYMENT_REPORT_FORM_FIELDS.TIMEZONE,
			placeholder: `${t(PAYMENT_REPORT_FORM_FIELDS_NAMES.TIMEZONE)}`,
			label: t(PAYMENT_REPORT_FORM_FIELDS_NAMES.TIMEZONE),
			inputType: InputType.Select,
			data: timeZonesList,
			// placement: 'bottomEnd',
			required: true,
		},
	];
};
